import { Box } from '@base-app';
import { styled } from '@/stitches.config';

export const StyledDateContainer = styled(Box, {
  display: 'flex',
  alignItems: 'center',
});

export const StyledSelectContainer = styled(Box, {
  marginLeft: '$4',
});

export const StyledBasicFilter = styled(Box, {
  display: 'flex',
  justifyContent: 'space-between',
  borderBottom: '$borderWidths$1 solid $colors$seafoam500',
  marginBottom: '$4',
  padding: '0 $4 $4 $4',
});

export const StyledDropdownFilters = styled(Box, { display: 'flex' });
